import { Link } from '@inertiajs/inertia-react'
import React from 'react'

const gmbPricing = [
    {
        id: 1,
        title: 'Basic Plan',
        price: '$99 / month',
        image: '/frontend/images/svg/icon-15.svg',
        description: 'Essential GMB optimization for small businesses to build local presence.',
        paymentUrl: '#',
        features: [
            'GMB Setup & Verification',
            'Info Optimization',
            'Category & Service Selection',
            '5 Photos Uploaded',
            'Monthly Report',
        ]
    },
    {
        id: 2,
        title: 'Standard Plan',
        price: '$199 / month',
        image: '/frontend/images/svg/icon-16.svg',
        description: 'Comprehensive GMB optimization with advanced local SEO and regular updates.',
        paymentUrl: '#',
        features: [
            'Everything in Basic',
            'Keyword Optimization',
            'Weekly GMB Posts',
            '15 Photos Uploaded',
            'Review Management',
            'Monthly Reports',
        ]
    },
    {
        id: 3,
        title: 'Premium Plan',
        price: '$399 / month',
        image: '/frontend/images/svg/icon-17.svg',
        description: 'Maximize GMB performance with full management and strategic optimization.',
        paymentUrl: '#',
        features: [
            'Everything in Standard',
            'Competitor Analysis',
            'GMB Ad Management',
            'Unlimited Photos/Videos',
            'Advanced Review Management',
            'Strategy Consultation',
        ]
    },
    {
        id: 4,
        title: 'Enterprise Plan',
        price: 'Custom Pricing',
        image: '/frontend/images/svg/icon-18.svg',
        description: 'Tailored GMB solutions with dedicated management and ongoing support.',
        paymentUrl: '#',
        features: [
            'Everything in Premium',
            'Custom Strategy',
            'Regular Audits',
            'Local SEO Monitoring',
            'Account Manager',
            'Priority Support',
        ]
    },
];




const GMBPricing = ({ modalIsOpen, setModalIsOpen }) => {
    return (
        <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 py-20 px-2">
                {
                    gmbPricing.map((item, index) => (
                        <div className="border-2 border-gray-100 py-6" key={index}>
                            {item.id === 2 && (
                                <div className="bg-green-300 flex justify-center items-center -mt-10">
                                    <h2 className="py-2 text-gray-700">Most Popular</h2>
                                </div>
                            )}
                            <div className="bg-white py-4 px-2">
                                <img src={item.image} className="py-2 px-2" alt={`${item.title}`} />
                                <h2 className="text-xl py-2">{item.title}</h2>
                                <p className="text-gray-700 py-2">{item.description}</p>
                                <h4 className="text-2xl text-gray-900 py-2">{item.price}</h4>
                                <ul className="py-4 px-2">
                                    {item.features.map((feature, index) => (

                                        <li className="flex items-center text-gray-700 py-4 px-2 border-b-2" key={index}>
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 mr-2" fill="none"><g fill="#48BB78" clipPath="url(#a)"><path d="M9.13 12.024a.765.765 0 0 1-.506-.19L4.852 8.505a.766.766 0 0 1 1.013-1.15l3.236 2.845 6.754-6.706a.768.768 0 1 1 1.079 1.094L9.67 11.81a.768.768 0 0 1-.54.215Z" /><path d="M8.661 17.541a8.502 8.502 0 0 1-8.38-9.88A8.5 8.5 0 0 1 11.388.987a.766.766 0 1 1-.492 1.45 6.969 6.969 0 1 0 4.45 8.581.765.765 0 1 1 1.468.438 8.548 8.548 0 0 1-8.152 6.084Z" /></g><defs><clipPath id="a"><path fill="#fff" d="M.161.542h17v17h-17z" /></clipPath></defs></svg>
                                            {feature}
                                        </li>

                                    ))}
                                </ul>
                                <div className="flex items-center text-gray-700 py-2 ml-4 px-2">
                                    {/* <a href={item.paymentUrl} className="button w-full py-4 px-4 text-white text-center">Get Started {item.title}</a> */}
                                    <button
                                        onClick={() => {
                                            setModalIsOpen(!modalIsOpen)
                                            mixpanel.track("Schedule a meeting SEO Pricing button clicked");
                                        }}

                                        className="relative w-full py-3 px-3 top-1 right-2 button rounted-sm text-gray-700 hover:bg-green-500"
                                    >
                                        <span className="text-xl">Schedule a meeting</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))
                }
            </div>
            <div className="flex flex-col items-center">
                <p className="py-2 ">*Prices are based on monthly plans, and can be subscribed and unsubscribed at any time.</p>
                <a href="#pricing" className="button text-gray-700 py-4 px-4">See all plans details</a>
            </div>
        </div>
    )
}
export default GMBPricing
